import { getApiUrl } from '../../../Url';

type StartMediaTranscodingParameters = {
  userId: number | null;
  webEpisodeId?: string;
};

type StartMediaTranscodingResponse = {
  episodeId: number;
  episodeUri: string;
  status: 'COMPLETE' | 'IN_PROGRESS' | 'FAILED' | 'NO_UPLOAD';
  seen: boolean;
};

export async function startMediaTranscoding({
  userId,
  webEpisodeId,
}: StartMediaTranscodingParameters): Promise<StartMediaTranscodingResponse> {
  try {
    const resp = await fetch(
      getApiUrl({
        path: `transcoding/episode/webEpisodeId:${webEpisodeId}`,
        queryParameters: { userId },
      }),
      {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
    if (resp.ok) {
      return resp.json();
    }

    throw new Error(`Could not create transcode media request`);
  } catch (e) {
    throw new Error(e.message);
  }
}
